<template>
  <div
    class="drop-down-button flex-center"
    ref="buttonDropDown"
    :class="[
      hasBorderParent ? 'border-drop-down-btn ' + dbOptionHeight + '-border' : dbOptionHeight,
      disabled ? 'disabled-btn' : '',
      isBtnFooterHelpFul && !isBtnPrint ? 'btn-footer-helpful' : '',
    ]"
  >
    <menu-wrapper
      class="widget-more-container widget-btn"
      :class="[type]"
      :disabled="disabled"
      :maxHeight="maxHeight"
      :position="position"
    >
      <template #menu-button="{toggleMenu}">
        <div :class="[isBtnPrint ? 'btn-print' : '', 'left-button']">
          <button
            class="btn flex-row primary-button"
            :class="[type, classCustom, hasBorder ? dbOptionHeight + '-border' : dbOptionHeight + ' btn-border-none']"
            :disabled="disabled"
            @click.prevent="
              e =>
                isBtnPrint
                  ? printPreviousReport(e, toggleMenu, toggleMainMenu.bind(this, e, toggleMenu))
                  : toggleMainMenu(e, toggleMenu)
            "
          >
            <div :class="['icon24 icon left', leftIcon]" v-if="leftIcon">&nbsp;</div>
            <div class="text" :class="[{'pl-0': leftIcon}]" v-if="text">
              {{ text }}
            </div>
          </button>
        </div>
        <div class="button-line"></div>
        <div :class="[isBtnPrint ? 'btn-print' : '', 'right-icon']">
          <button
            @click.prevent="e => toggleMainMenu(e, toggleMenu)"
            :class="[
              type,
              classCustom,
              hasBorder ? dbOptionHeight + '-border' : dbOptionHeight + ' btn-border-none',
              isBtnFooterHelpFul ? 'footer' : '',
              heightOption == 2 ? 'widget-more' : hasBorder ? 'widget-more-small-border' : 'widget-more-small',
            ]"
            :disabled="disabled"
          ></button>
        </div>
      </template>
      <template #menu-content>
        <menu-item
          v-for="(item, index) in menuItemFilter"
          :key="index"
          :seperatorBottom="item.seperatorBottom"
          :disabledItem="item.disabledItem || (offlineReady && item?.isDisableWhenOffline)"
          @menu-item-click="clickItem(item)"
          :class="[item.class, item.IsSubMenu && 'menu-group-item', item.IsSubMenu && 'menu-sub-group' + index]"
          @mouseenter="
            e => {
              item.IsSubMenu && toogleMenu(e, index, item);
              item.onHover = true;
            }
          "
          @mouseleave="
            e => {
              item.IsSubMenu && toogleMenu(e, index, item);
              item.onHover = false;
            }
          "
        >
          <div v-if="item.IsSubMenu">
            <div class="flex-between flex1">
              <div class="content">{{ item.text }}</div>
              <div :class="['icon24 icon right-arrow-black', item.icon]" :ref="'buttonContainerSub' + index"></div>
            </div>
            <teleport to="body">
              <ul
                class="menu-wrapper-menu"
                :class="[classRoot, 'menu-sub-group' + index]"
                v-if="item.isShow"
                :ref="'listSub' + index"
                :name="''"
                :style="{
                  left: left,
                  right: right,
                  top: top,
                  bottom: bottom,
                  maxHeight: maxHeight + 'px',
                  overflow: 'auto',
                }"
                @mouseover="e => toogleMenu(e, index, item)"
                @mouseleave="e => toogleMenu(e, index, item)"
              >
                <menu-item
                  v-for="(itemSub, index) in item.subItem"
                  :key="index"
                  :disabledItem="offlineReady && itemSub?.isDisableWhenOffline"
                  :class="{'initial-focus': item.onHover && itemSub.initial}"
                  @menu-item-click="clickItem(itemSub)"
                  >{{ itemSub.text }}</menu-item
                >
              </ul>
            </teleport>
          </div>
          <div v-else>
            {{ item.text }}
          </div>
        </menu-item>
      </template>
    </menu-wrapper>
  </div>
</template>
<script>
import {defineComponent, computed, ref, getCurrentInstance, nextTick, watch, reactive, onMounted} from 'vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import componentUtil from '@/commons/componentUtil';
import {ModuleOfflineWork} from '@/stores/moduleConst';

export default defineComponent({
  name: 'msDropDownButton',
  components: {
    MenuWrapper,
    MenuItem,
  },
  props: {
    //Text hiển thị
    text: {
      default: null,
      type: String,
    },
    //Icon trái
    leftIcon: {
      default: null,
      type: String,
    },
    //Icon phải
    rightIcon: {
      default: 'chevron-down-white',
      type: String,
    },
    //Loại button gồm 3 loại primary/secondary/third/four để hiện thị style tương ứng
    type: {
      default: 'primary',
      type: String,
    },
    /**
     * Trạng thái button disabled
     */
    disabled: {
      default: false,
      type: Boolean,
    },
    // chiều cao tối đa cho menu để hiển thị scroll nếu menu quá dài
    maxHeight: {
      default: null,
      type: [Number, String],
    },
    /**
     * Danh sách các item của context menu
     */
    menuItems: {
      type: Array,
      default: new Array(),
    },
    /**
     * ĐVThi 18/02/2020
     * muốn đặt thêm stype cho lớp mục đích có cách để trên form tìm được đến control
     */
    classCustom: {
      default: '',
      type: String,
    },
    /**
     * NNLAM 26/02/2020
     * có cho phép tự custom vị trí dropdown menu hay không
     */
    customPositionMenu: {
      type: Boolean,
      default: false,
    },
    /**
     * NNLAM 26/02/2020
     * Set lại chiều dài menu dropdown
     */
    customWidth: {
      type: Number,
      default: 0,
    },
    /**
     * NNLAM 26/02/2020
     * khoảng cách của button so với lề trên/dưới
     */
    heightOffset: {
      type: Number,
      default: 5, //25
    },
    /**
     * NNLAM 26/02/2021
     * khoảng cách của button so với lề trái/phải
     */
    widthOffset: {
      type: Number,
      default: 25,
    },
    /**
     * NNLAM 26/02/2021
     * Có show menu khi click vào icon right của button không, mặc định có
     */
    hasShowMenu: {
      type: Boolean,
      default: true,
    },
    /**
     * NNLAM 26/02/2021
     * Có tooltip cho btt không
     */
    tooltipText: {
      type: [String, Object],
      default: null,
    },
    //border hiển thị cho các button con
    hasBorder: {
      default: false,
      type: Boolean,
    },
    //border bên ngoài 2 button con
    hasBorderParent: {
      default: false,
      type: Boolean,
    },
    // button tiện ích footer có hover màu xanh nước biển
    isBtnFooterHelpFul: {
      default: false,
      type: Boolean,
    },
    /**
     * Thêm class root để style menu-wrapper
     * tbngoc 19.07.2022
     */
    classRoot: {
      default: '',
      type: String,
    },
    position: {
      default: null,
      type: Object,
    },
    byDateClose: {
      default: false,
      type: Boolean,
    },
    /**
     * Có phải là button "In" hay không
     * NBTIN 14.12.2023
     */
    isBtnPrint: {
      default: false,
      type: Boolean,
    },
  },
  setup(props, {emit}) {
    // Các thuộc tính cho subMenu
    const top = ref(0);
    const left = ref('unset');
    const right = ref('unset');
    const bottom = ref('unset');
    const position = reactive({
      at: 'right+15 top+20',
      my: 'left bottom',
    });
    const {proxy} = getCurrentInstance();

    const menuItemFilter = computed(() => {
      if (props.menuItems.length > 0 && props.text == 'Tiện ích' && props.byDateClose) {
        //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
        return props.menuItems.filter(x => {
          if (x.hasOwnProperty('command') && x.command != 'Delete' && x.command != 'SalaryAllocation') {
            return true;
          } else if (x.hasOwnProperty('Command') && x.Command != 'Delete' && x.command != 'SalaryAllocation') {
            return true;
          } else {
            return false;
          }
        });
      }
      return props.menuItems;
    });

    const clickItem = item => {
      emit('menuClick', item);
    };
    /**
     * Sự kiện in lại mẫu in gần nhất trên chứng từ
     * NBTIN 14.12.2023
     */
    const printPreviousReport = (e, toggleMenu, toggleMainMenu) => {
      emit('printPreviousReport', e, toggleMenu, toggleMainMenu);
    };
    //const toggleMenu = ref(false);
    // end -----------------------------------------------------------------------
    /**
     * Set sự kiện cho menu được hiển thị
     * tbngoc 01.08.2022
     */
    function setPosition(parent, group, posi) {
      top.value = '0px';
      left.value = '0px';

      nextTick(() => {
        let positions = componentUtil.getPosition(parent, group, posi);

        top.value = positions.top + 'px';
        left.value = positions.left + 'px';
      });
    }
    /**
     * Sự kiện toggle menu tại item trong dropdown button
     * tbngoc 01.08.2022
     */
    function toogleMenu(e, index, item) {
      e.stopPropagation();
      if (!proxy.disabled) {
        let ele = e.toElement;
        ele = ele || (e.type == 'mouseenter' ? e.originalTarget : e.relatedTarget);
        let group = ele.closest('.menu-sub-group' + index);
        if (group) {
          item.isShow = true;
          nextTick(() => {
            setPosition(
              proxy.$refs['buttonContainerSub' + index][0],
              proxy.$refs['listSub' + index][0],
              item.position || position,
            );
          });
        } else {
          item.isShow = false;
        }
      }
    }

    function toggleMainMenu(event, toggleMenu) {
      if (toggleMenu && typeof toggleMenu === 'function') {
        toggleMenu(event);
      }
      if (menuItemFilter.value && Array.isArray(menuItemFilter.value)) {
        menuItemFilter.value.forEach(item => (item.isShow = false));
      }
    }

    const dbOptionHeight = computed(() => {
      return 'heightoptionvalue' + parseInt(proxy.$store?.state?.dbOption?.dbOptions.HeightOption || 2);
    });

    const heightOption = computed(() => {
      return proxy.$store?.state?.dbOption?.dbOptions.HeightOption || 2;
    });

    const offlineReady = computed(() => {
      if (!proxy.$store.state[ModuleOfflineWork]) {
        return false;
      } else {
        return proxy.$store.state[ModuleOfflineWork].offlineReady;
      }
    });

    return {
      offlineReady,
      clickItem,
      top,
      left,
      right,
      bottom,
      toogleMenu,
      toggleMainMenu,
      menuItemFilter,
      dbOptionHeight,
      heightOption,
      printPreviousReport,
    };
  },
});
</script>

<style scoped lang="scss">
@import '@/assets/scss/components/MsButton.scss';

:deep(.btn) {
  min-width: 60px;
}

.drop-down-icon {
  width: 36px;
  height: 24px;
  margin: 0 !important;
  .icon {
    margin: 0;
    cursor: pointer;
  }
}

:deep(.menu-button-container) {
  display: flex;
}
:deep(.flex) {
  display: flex;
}
:deep(.wrapper-utilities) {
  z-index: 1000 !important;
}
.context-item {
  height: 36px;
  padding: 2px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  .context-text {
    padding: 0 8px;
  }
  &:hover {
    cursor: pointer;
    background: $hover-bg;
    color: #14aa8a;
  }
}
.context-icon {
  margin-right: 8px;
}
.color-red {
  color: #ff0000;
}
.button-line {
  display: inline-block;
  width: 1px;
  height: 16px;
  background-color: #fff;
}
.drop-down-button {
  &.border-drop-down-btn {
    border: 1px solid #afafaf;
    border-radius: 3px;
  }
  button {
    &.primary-button {
      border-end-end-radius: unset;
      border-start-end-radius: unset;
    }
  }
}
.menu-button-container {
  .heightoptionvalue1-border {
    height: $input-height-custom-small !important;
  }
  .heightoptionvalue1 {
    height: $input-height-custom-small-no-border !important;
  }
  .heightoptionvalue2-border {
    height: $input-height-custom-big !important;
  }
  .heightoptionvalue2 {
    height: $input-height-custom-big-no-border !important;
  }
  .widget-more-small-border {
    height: $input-height-custom-small;
    width: $input-height-custom-small;
    position: relative;
    border: none;
    background: none;
    outline: none;
    padding: 0;

    &:hover {
      cursor: pointer;
    }

    &::before {
      content: '';
      position: absolute;
      height: $input-height-custom-small;
      width: $input-height-custom-small;
      top: 0;
      left: 0;
      background: transparent url($ms-image-sprites) no-repeat -434px -48px;
    }
  }

  .widget-more-small {
    height: $input-height-custom-small-no-border;
    width: $input-height-custom-small-no-border;
    position: relative;
    border: none;
    background: none;
    outline: none;
    padding: 0;

    &:hover {
      cursor: pointer;
    }

    &::before {
      content: '';
      position: absolute;
      height: $input-height-custom-small-no-border;
      width: $input-height-custom-small-no-border;
      top: 0;
      left: 0;
      background: transparent url($ms-image-sprites) no-repeat -434px -48px;
    }
  }
  .btn-print {
    position: relative;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: transparent;
      border-radius: 2px;
    }
    &:focus-within {
      &::before {
        background-color: #d4d7dc;
        opacity: 0.2;
      }
      .widget-more.footer:before {
        background-position: -433px -74px !important;
      }
      .widget-more-small.footer:before {
        background-position: -433px -74px !important;
      }
      .widget-more-small-border.footer:before {
        background-position: -433px -74px !important;
      }
    }
  }
  .left-button {
    margin-left: 7px;
  }
  .right-icon {
    margin-right: 7px;
  }
}
.down-arrow-black-custom {
  .icon24 {
    &:before {
      background-position: -331px -48px;
    }
    left: 15px;
  }
  &:hover .icon24::before {
    background-position: -355px -48px;
  }
}
</style>
